"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Type;
(function (Type) {
    Type["string"] = "string";
    Type["number"] = "number";
    Type["boolean"] = "boolean";
    Type["object"] = "object";
    Type["function"] = "function";
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/types.js
// module id = 7
// module chunks = 0